<template>
  <div class="product-detail" id="shopcase">
    <div class="product-box">
      <div class="product-title">产品特点</div>
      <div class="product-content" v-html="productCharacteristics"></div>
    </div>
    <div class="product-box">
      <div class="product-title">产品优势</div>
      <div class="product-content" v-html="productAdvantage"></div>
    </div>
    <div class="product-box">
      <div class="product-title">应用案例</div>
      <div class="product-content" v-html="applicationColumn"></div>
    </div>
  </div>
</template>

<script>
// import { GoodsDesc2 } from '@/api/resetApi.js'

export default {
  name: 'shopcase',
  data() {
    return {
      gpId: '',
      productCharacteristics: '',
      productAdvantage: '',
      applicationColumn: '',
    }
  },
  created(){
    if(this.$route.query.itId){
      this.gpId = this.$route.query.itId
    }
    this.getGoodsDetailDesc()
  },
  methods: {
    async getGoodsDetailDesc() {
      let data = {
        'gpId': this.gpId
      }
      const res = await GoodsDesc2(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.productCharacteristics = res.data.data.packageProductFeatures
          this.productAdvantage = res.data.data.packageProductAdvantages
          this.applicationColumn = res.data.data.packageProductApplicationCase
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.product-detail {
  padding: 0.1rem 0 0 0.1rem;
  .product-box {
    margin-bottom: 0.1rem;
    border-bottom: 0.01rem solid #f1f1f1;
    .product-content {
      padding: 0.1rem 0;
      word-wrap:break-word;
      white-space:pre-wrap;
      font-size: 0.12rem;
      color: #181818;
      text-align: left;
      line-height: 0.18rem;
    }
  }
  .product-img {
    padding-right: 0.1rem;
    word-wrap:break-word;
    white-space:pre-wrap;
    font-size: 0.12rem;
    color: #181818;
    img {
      max-width: 100%;
    }
  }
}
.product-title {
  border-left: 0.04rem solid #EA4747;
  padding-left: 0.1rem;
  text-align: left;
  font-size: 0.16rem;
  font-weight:bold;
  color: #181818;
}
</style>